import { extend } from 'lodash';

// FaultySegment model for the faulty segments
export class CtxFaultySegment {
    Name: string;
    ID: number;
    ErrorMessage: string;
    LastRunAt: string;

    public static fromJSON(params: any = {}): CtxFaultySegment {
        const faultySegment = extend(new CtxFaultySegment(), params);
        return faultySegment;
    }
}
